import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Trans } from 'react-i18next'
import { ReactComponent as TitleSuggestion } from 'core/assets/images/title-suggestion.svg'
import i18n from 'core/common/i18n'
import { Grid } from 'core/components/Core'
import Modal from 'core/components/Modal'
import Typography from 'core/components/Typography'
import { StyledList } from './styled'

function ModalTitulo({ open, handleClose }) {
  return (
    <Modal
      aria-labelledby="customized-dialog-title"
      textCancel={i18n.t('general.close')}
      onCancel={handleClose}
      open={open}
      fullWidth
      maxWidth="lg"
    >
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item md={4}>
          <TitleSuggestion />
        </Grid>
        <Grid item md={8}>
          <Typography component="span">{i18n.t('product.modal.title.sugestion')}</Typography>

          <StyledList component="div">
            <Trans components={{ ul: <ul />, li: <li /> }} i18nKey="product.modal.title.list" />
          </StyledList>

          <Typography>{i18n.t('product.modal.title.youCanDo')}</Typography>
          <Typography>
            <Trans components={{ b: <b /> }} i18nKey="product.modal.title.recommendation" />
          </Typography>

          <Typography py={2}>
            <Trans
              components={{
                red: <span style={{ color: 'red' }} />,
                green: <span style={{ color: 'green' }} />,
              }}
              i18nKey="product.modal.title.doDontDo"
            />
          </Typography>
        </Grid>
      </Grid>
    </Modal>
  )
}

ModalTitulo.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default memo(ModalTitulo)
